import React from "react";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";
import EventEHRSwitchButton from "../../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";

interface InventoryProps {
  rowData: any[];
  setInventoryRowData: (data: any[]) => void;
}

const Inventory = ({ rowData, setInventoryRowData }: InventoryProps) => {

  const inventoryColumns = [
    {
      field: "roles",
      label: <div>Permission</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.roles}</p>;
      },
    },
    {
      field: "description",
      label: <div>Description</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.description}</p>;
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        return (
          <div className="flex justify-center">
            <EventEHRSwitchButton
              checked={row?.status}
              onChange={() => {
                const updatedData = rowData?.map((item: any, i: any) =>
                  i === index ? { ...item, status: !item.status } : item
                );
                setInventoryRowData(updatedData);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="pt-4">
      <Heading title="Inventory" customStyle={{ fontSize: "16px", fontWeight: "600" }} />
      <div className="pt-2">
        <Table
          columns={inventoryColumns}
          rows={rowData}
          paginationProps={{
            isPagination: false,
          }}
          noDataFoundMessage={"No inventory permissions found"}
        />
      </div>
    </div>
  );
};

export default Inventory;
